import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullDealLocation from "./fragments/dealLocation"

const query = gql`
  query dealLocations($dealId: String, $lat: Float, $lng: Float, $radius: Int, $offset: Int, $limit: Int) {
    dealLocations(dealId: $dealId, lat: $lat, lng: $lng, radius: $radius, offset: $offset, limit: $limit) {
      results {
        ...fullDealLocation
      }
      offset
      total
    }
  }
  ${fullDealLocation}
`
export const toString = query.loc.source.body

export const stockJobListKey = getQueryNames(query)[0]

export default query
